const CreativeAgencyOneService = () => {
  return (
    <>
      <div className="ca-service-section section-space bgc-secondary">
        <div className="section-space--sm-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-xl-6">
                <h4 className="heading-4 mb-0 clr-white text-center">
                  We Are Provide Best Service For Your Business
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row g-4 gy-5 gx-md-5">
            <div className="col-md-6 col-xl-4">
              <div className="bgc-white padding-6 rounded-3 d-flex flex-wrap flex-md-nowrap gap-4 position-relative">
                <div className="d-grid place-content-center width-20 height-20 rounded-circle bgc-warning flex-shrink-0">
                  <img
                    src="assets/img/creative-agency/icon-book.png"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="heading-6 clr-text font-weight-bold">
                    Online Marketing
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    We provide best IT solutions for any type of business as
                    company strategy management.
                  </p>
                </div>
                <span className="position-absolute end-0 bottom-0 width-30 height-30 rounded-3 bgc-warning z-n1 translate-12"></span>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="bgc-white padding-6 rounded-3 d-flex flex-wrap flex-md-nowrap gap-4 position-relative">
                <div className="d-grid place-content-center width-20 height-20 rounded-circle bgc-success flex-shrink-0">
                  <img
                    src="assets/img/creative-agency/icon-pen-pencil.png"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="heading-6 clr-text font-weight-bold">
                    UI & UX Design
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    We provide best IT solutions for any type of business as
                    company strategy management.
                  </p>
                </div>
                <span className="position-absolute end-0 bottom-0 width-30 height-30 rounded-3 bgc-success z-n1 translate-12"></span>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="bgc-white padding-6 rounded-3 d-flex flex-wrap flex-md-nowrap gap-4 position-relative">
                <div className="d-grid place-content-center width-20 height-20 rounded-circle bgc-danger flex-shrink-0">
                  <img
                    src="assets/img/creative-agency/icon-shield.png"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="heading-6 clr-text font-weight-bold">
                    Development
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    We provide best IT solutions for any type of business as
                    company strategy management.
                  </p>
                </div>
                <span className="position-absolute end-0 bottom-0 width-30 height-30 rounded-3 bgc-danger z-n1 translate-12"></span>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="bgc-white padding-6 rounded-3 d-flex flex-wrap flex-md-nowrap gap-4 position-relative">
                <div className="d-grid place-content-center width-20 height-20 rounded-circle bgc-base flex-shrink-0">
                  <img
                    src="assets/img/creative-agency/icon-security.png"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="heading-6 clr-text font-weight-bold">
                    SEO Marketing
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    We provide best IT solutions for any type of business as
                    company strategy management.
                  </p>
                </div>
                <span className="position-absolute end-0 bottom-0 width-30 height-30 rounded-3 bgc-base z-n1 translate-12"></span>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="bgc-white padding-6 rounded-3 d-flex flex-wrap flex-md-nowrap gap-4 position-relative">
                <div className="d-grid place-content-center width-20 height-20 rounded-circle bgc-danger flex-shrink-0">
                  <img
                    src="assets/img/creative-agency/icon-settings.png"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="heading-6 clr-text font-weight-bold">
                    Technology
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    We provide best IT solutions for any type of business as
                    company strategy management.
                  </p>
                </div>
                <span className="position-absolute end-0 bottom-0 width-30 height-30 rounded-3 bgc-danger z-n1 translate-12"></span>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="bgc-white padding-6 rounded-3 d-flex flex-wrap flex-md-nowrap gap-4 position-relative">
                <div className="d-grid place-content-center width-20 height-20 rounded-circle bgc-warning flex-shrink-0">
                  <img
                    src="assets/img/creative-agency/icon-award.png"
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="heading-6 clr-text font-weight-bold">
                    Brand Identities
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    We provide best IT solutions for any type of business as
                    company strategy management.
                  </p>
                </div>
                <span className="position-absolute end-0 bottom-0 width-30 height-30 rounded-3 bgc-warning z-n1 translate-12"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyOneService;
